import { withPreloadedJSON } from "@wss/hypernova";
import FooterContainer from ".";

export const Footer = withPreloadedJSON(FooterContainer, "Footer");
